import { OrderStatistics } from '@api/shipping-data/types/OrderStatistics';
import { DeliveryStatus } from '@api/shipping-data/types/DeliveryStatus';
import { OrderDates } from 'components/order-elements/OrderDates';
import { OrderTimes } from 'components/order-elements/OrderTimes';
import { InfobarValues, Infobar } from 'components/order-elements/Infobar';



interface OrderStatusProps {
	orderStatistics: OrderStatistics;
}


export const OrderStatus = (props: OrderStatusProps) => {
	const { containsBeer, containsTank, containsFreeBeer, containsCollection, containsEmpties, containsPosm, containsClaim, containsUnknown,
		orderOriginalRequiredDeliveryDate, orderRequiredDeliveryDate,
		deliveryStatus, orderReduced, orderRedated, orderCancelled, smsWasSent, deliveryDateDeviationInMinutes, shipmentPlannedArrival, shipmentEtaArrival, deliveryRealArrival,
		deliveryReducedDueToPpas, deliveredDeliveryReducedDueToPpas,
		orderItemsCount, deliveryItemsCount, deliveredDeliveryItemsCount, orderItemsVolume, deliveryItemsVolume, deliveredDeliveryItemsVolume
	} = props.orderStatistics;

	const countValues: InfobarValues = {
		value1: orderItemsCount,
		showExclamation1: orderReduced,
		value2: deliveryItemsCount,
		showExclamation2: deliveryReducedDueToPpas,
		value3: deliveredDeliveryItemsCount,
		showExclamation3: deliveredDeliveryReducedDueToPpas,
	};
	const volumeValues: InfobarValues = {
		value1: orderItemsVolume,
		showExclamation1: orderReduced,
		value2: deliveryItemsVolume,
		showExclamation2: deliveryReducedDueToPpas,
		value3: deliveredDeliveryItemsVolume,
		showExclamation3: deliveredDeliveryReducedDueToPpas,
	};

	return (
		<div className='order-status'>
			<OrderDates
				originalDeliveryDate={orderOriginalRequiredDeliveryDate ?? null}
				deliveryDate={orderRequiredDeliveryDate ?? null}
				smsWasSent={smsWasSent}
				isRedated={orderRedated}
			/>

			<OrderTimes 
				plannedArrival={shipmentPlannedArrival ?? null}
				realArrival={deliveryRealArrival ?? null}
				etaArrival={shipmentEtaArrival ?? null}
				deliveryStatus={deliveryStatus}
				smsWasSent={smsWasSent}
				arrivalsDeltaInMinutes={deliveryDateDeviationInMinutes ?? 0}
			/>

			<Infobar
				containsBeer={containsBeer}
				containsTank={containsTank}
				containsFreeBeer={containsFreeBeer}
				containsCollection={containsCollection}
				containsEmpties={containsEmpties}
				containsPosm={containsPosm}
				containsClaim={containsClaim}
				containsUnknown={containsUnknown}
				isCancelled={orderCancelled}
				isReduced={orderReduced}
				isDelivered={deliveryStatus === DeliveryStatus.delivered}
				countValues={countValues}
				volumeValues={volumeValues}
			/>
		</div>
	)
}